import cn from "classnames";
import { FC, PropsWithChildren, useMemo } from "react";

import styles from "./Page/Page.module.scss";

type PageContentProps = {
  margin?: string;
  backgroundColor?: string;
  transparent?: boolean;
  className?: string;
  flex1?: boolean;
  id?: string;
};

/**
 * Legacy page wrapper, now the same centred column as `Page` (shared/ui/Page). `margin` /
 * `backgroundColor` still override for the few screens that need their own frame.
 */
export const PageContent: FC<PropsWithChildren<PageContentProps>> = ({
  margin,
  backgroundColor,
  id,
  flex1 = true,
  className,
  children,
}) => {
  const customStyles = useMemo(() => {
    const s: React.CSSProperties = {};
    if (backgroundColor) s.backgroundColor = backgroundColor;
    if (margin) s.margin = margin;
    return s;
  }, [margin, backgroundColor]);

  return (
    <div id={id} className={cn(styles.page, flex1 && "flex-1", className)} style={customStyles}>
      {children}
    </div>
  );
};
